<template>
  <div v-if="sender && sender.id" class="d-flex flex-row flex-nowrap align-center" @click="$emit('change', sender)">
    <div>
      <div class="black--text" style="white-space: nowrap">
        <strong>
          {{ sender.name ? sender.name : sender.username }}
        </strong>
        ,
        <span style="white-space: nowrap; color: #797979; font-size: 12px">
          <span>{{ message.createdAt | getDate }}</span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { get } from 'lodash'
import moment from 'moment'

export default {
  props: {
    sender: Object,
    message: Object,
  },
  computed: {
    avatar() {
      return get(this.sender, 'avatar.url', '/default-avatar.svg')
    },
  },
  async created() {},
  methods: {},
  filters: {
    getDate(date) {
      return moment(date).utcOffset(7).format('DD/MM/YYYY HH:mm:ss')
    },
  },
}
</script>

<style lang="scss" scoped>
.image-wrapper {
  width: 55px;
  min-width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  img {
    max-width: 100%;
    max-height: 100%;
    border-radius: 4px;
  }
}
</style>
